// extracted by mini-css-extract-plugin
export default {"btnsec":"CopyRequest_btnsec__c2JHs","copy-request-btn":"CopyRequest_copy-request-btn__6mHA1"};